export default "__VITE_ASSET__Duf0B$Cf__"